module.exports = __webpack_public_path__ + "img/mln.d62f0481.svg";